























import http from '@/http';
import { Component, Watch, Mixins } from 'vue-property-decorator';
import UpdateMixins from '@/mixins/UpdateMixins';
import _ from 'lodash';
import { mapActions } from 'vuex';

@Component({
  methods: {
    ...mapActions('SystemData', {
      initSystemData: 'init',
    }),
  },
})
export default class App extends Mixins(UpdateMixins) {
  initSystemData!: () => void;

  beforeCreate() {
    console.debug('App.beforeCreate');
    http.v1.initBearerToken();
  }

  async created() {
    // jwt
    console.debug('App.created');
    await http.v1.init();

    await this.initSystemData();

    const appLoading = document.getElementById('loader');
    if (appLoading) {
      appLoading.style.display = 'none';
    }

    // store the share_code if it exists in url query
    if (this.$route.query && _.has(this.$route.query, 'share_code')) {
      this.$store.commit(
        'ShareCode/SET_SHARE_CODE',
        this.$route.query.share_code
      );
    }
  }

  @Watch('$route')
  watchRoute(to) {
    const appTitle = process.env.VUE_APP_TITLE;
    if (to.meta.pageTitle) {
      document.title = to.meta.pageTitle + '-' + appTitle;
    } else {
      (document as { title }).title = appTitle;
    }
  }
  @Watch('$store.state.Auth.activeKeys')
  watchActiveKeys(activeKeys) {
    if (activeKeys.length > 0) {
      this.$acl.change(activeKeys);
    } else {
      this.$acl.change('guest');
    }
  }
}
